import React from 'react';
import { Box, CircularProgress } from '@mui/material';
import PieChartOutlineIcon from '@mui/icons-material/PieChartOutline';
import { getCountryChipDisplay } from '../components/shared/securityDisplayPrimitives';

export default function PerformanceViewTabLabel({ card, label, attributesMeta = [], loading = false, loadingStatusLabel }) {
    const country = card.scope === 'attribute'
        && card.attributeGroup?.group_kind === 'assigned'
        && attributesMeta.some((meta) => meta.definitionId === card.attributeDefinitionId && meta.systemKey === 'country');
    const flag = country ? getCountryChipDisplay(card.attributeGroup.group_value).flag : '';
    return <Box component="span" sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.75, whiteSpace: 'nowrap' }}>
        {card.scope === 'portfolio' && <PieChartOutlineIcon aria-hidden="true" sx={{ fontSize: 17 }} />}
        {flag && <Box component="span" aria-hidden="true" sx={{ fontSize: 16, lineHeight: 1 }}>{flag}</Box>}
        {label}
        <Box component="span" role={loading ? 'status' : undefined} aria-label={loading ? loadingStatusLabel || `Loading ${label}` : undefined} sx={{ display: 'inline-flex', width: 14, height: 14, flexShrink: 0 }}>
            {loading && <CircularProgress size={14} aria-label={`Loading ${label}`} />}
        </Box>
    </Box>;
}
